<template>
  <form class="step"
        novalidate
        @submit.prevent="submit">
    <div class="step-row">
      <input-field v-model="form.name"
                   name="fund-name"
                   v-validate="'required'"
                   class="field_large"
                   :label="i18n.sale_campaign_name()"
                   :placeholder="i18n.sale_campaign_name_label()"
                   :errorMessage="errorMessage('fund-name')"
      />
      <template v-for="(row, i) in schema.rows">
        <div class="step__row" :key="i">
          <template v-for="item in row">
            <file-field v-if="item.field === 'file'"
                        v-model="documents[item.type]"
                        class="step__file-field"
                        @file-delete="fileDelete()"
                        :fileType="item.fileType"
                        :private="item.private"
                        :label="item.label"
                        :type="item.type"
                        :id="item.id"
                        :key='item.id'
                        :fieldType="item.fieldType"
                        :disableField="loadVideoId"
            />
          </template>
        </div>
      </template>
      <div class="text_small text_margin"> {{ i18n.tx_blocks_separator() }} </div>

      <div class="container_40 step-row__video video">
        <div class="step-row__title text_small"> {{ i18n.sale_video_title() }} </div>
        <div class="video__add">
          <input-field v-model="videoPreview"
                       class="video__add-input"
                       name="sale-campaign-name"
                       id="sale-campaign-name"
                       :placeholder="i18n.sale_video_past()"
                       @input="setVideoPreview()"
          />
        </div>
        <div v-if="videoError" class="text_description text_small">{{ i18n.sale_video_preview_error() }}</div>
        <div class="text_description text_margin text_small">{{ i18n.sale_video_formats() }}</div>
        <div v-if="form.youtubeId" class="video-added__item">
          <iframe :src="`https://www.youtube.com/embed/${form.youtubeId}`"
                  class="video-frame video-frame_short"
          ></iframe>
          <div @click="deleteVideo('youtubeId')" class="video-added__item-del">
            <md-icon md-src="/static/img/cancel_icon.svg"/>
            <span class="text_x_small text_description">{{ i18n.lbl_delete() }}</span>
          </div>
        </div>
      </div>

      <!--<div class="step-row__title text_small">{{ i18n.sale_campaign_description() }}</div>-->

      <textarea-field v-model="form.shortDescription"
                      class="field_large"
                      v-validate="'max:2000'"
                      name="sale-description"
                      id="sale-description"
                      :label="i18n.sale_campaign_description()"
                      :disabled="form.convert"
                      :errorMessage="errorMessage('recipient')"
      />

      <!--<description-editor class="field_large" v-model="form.description"/>-->

      <input-field v-model="videoDescription"
                   class="field_large"
                   name="sale-video-description"
                   id="sale-video-description"
                   :label="i18n.sale_add_video()"
                   :placeholder="i18n.sale_add_video_label()"
      />
      <iframe :src="`https://www.youtube.com/embed/${getYoutubeId(videoDescription)}`"
              class="video-frame"
              v-if="videoDescription"></iframe>
      <md-button @click="addVideo()" class="md-primary">{{ i18n.lbl_add_more() }}</md-button>
      <div v-if="form.videoDescriptionArray.length !== 0" class="video-added__wrap">
        <div>{{ i18n.lbl_added_video() }}</div>
        <div v-for="(item, i) in form.videoDescriptionArray" :key="i" class="video-added__item">
          <iframe :src="`https://www.youtube.com/embed/${form.videoDescriptionArray[i]}`"
                  class="video-frame"
          ></iframe>
          <div @click="deleteVideo(i)" class="video-added__item-del">
            <md-icon md-src="/static/img/cancel_icon.svg"/>
            <span class="text_x_small text_description">{{ i18n.lbl_delete() }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrap column">
      <md-button type="submit" class="btn md-primary" :disabled="isPending">
        {{ i18n.sale_next_step() }}
      </md-button>
      <md-button @click="stepBack()" class="simple-link arrow_back">
        {{ i18n.lbl_go_back_2() }}
      </md-button>
    </div>
  </form>
</template>

<script>
  import StepMixin from './step.mixin'
  import _pick from 'lodash/pick'
  import { usersService } from '@api/users.service'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { commonEvents } from '@js/events/common_events'
  import { documentTypes, blobTypes } from '@const'
  import { i18n } from '@js/i18n'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import DescriptionEditor from '../components/DescriptionEditor'

  export default {
    name: 'Step-default',
    mixins: [ StepMixin ],
    components: { DescriptionEditor },
    props: ['schema'],
    data: _ => ({
      form: {
        name: '',
        description: '',
        shortDescription: '',
        youtubeId: '',
        videoDescriptionArray: []
      },
      documents: {
        [documentTypes.fundLogo]: ''
      },
      videoPreview: '',
      videoDescription: '',
      loadVideoId: false,
      videoError: false,
      i18n
    }),
    created () {
      if (this.schema) {
        this.form = _pick(this.sale, Object.keys(this.form))
        delete this.form.docs
        this.documents = {
          [documentTypes.fundLogo]: this.sale.logo
        }
      }
      if (this.form.youtubeId) this.loadVideoId = true
    },
    methods: {
      getYoutubeId (link) {
        if (!link) return
        this.videoError = false

        let videoId = ''

        if (link.split('v=')[1]) {
          videoId = link.split('v=')[1]
        } else if (link.split('youtu.be/')[1]) {
          videoId = link.split('youtu.be/')[1]
        } else {
          this.videoError = true
        }

        let ampersandPosition = videoId.indexOf('&')
        if (ampersandPosition !== -1) {
          videoId = videoId.substring(0, ampersandPosition)
        }
        return videoId
      },
      stepBack () {
        this.$emit(commonEvents.saleStepBack)
      },
      addVideo () {
        if (!this.videoDescription) return
        let linkID = this.getYoutubeId(this.videoDescription)
        this.form.videoDescriptionArray.push(linkID)
        this.videoDescription = ''
      },
      deleteVideo (i) {
        if (i === 'youtubeId') {
          this.videoPreview = ''
          this.form.youtubeId = ''
          this.loadVideoId = false
        } else {
          this.form.videoDescriptionArray = this.form.videoDescriptionArray.filter((name, item) => {
            return i !== item
          })
        }
      },
      async submit () {
        if (this.videoDescription) {
          this.form.videoDescriptionArray.push(this.getYoutubeId(this.videoDescription))
          this.videoDescription = ''
        }
        if (!await this.isValid()) return
        if (!this.documents[documentTypes.fundLogo] && !this.form.youtubeId.length) {
          EventDispatcher.dispatchShowErrorEvent(i18n.mod_empty_fund_logo())
          return
        } else if (!this.form.shortDescription.length) {
          EventDispatcher.dispatchShowErrorEvent(i18n.mod_empty_fund_description())
          return
        }
        this.disable()
        try {
          const descriptionId = (await usersService
            .blobsOf(this.userAccountId)
            .create(blobTypes.fundOverview.str,
              this.form.shortDescription, {}, false))
            .data('id')
          this.form.descriptionID = descriptionId
          await this.uploadDocuments()
          this.$emit(commonEvents.saleUpdateEvent, {
            form: this.form,
            documents: this.documents
          })
        } catch (error) {
          ErrorHandler.processUnexpected(error)
        }
        this.enable()
      },
      setVideoPreview () {
        this.form.youtubeId = this.getYoutubeId(this.videoPreview)
        this.loadVideoId = true
        this.fileDelete()
      },
      fileDelete () {
        this.documents = {}
      }
    }
  }
</script>

<style scoped lang="scss">
  @import './step.scss';
</style>



// WEBPACK FOOTER //
// src/vue/app/saleCreation/steps/Step.Default.vue